import path from "path";
import * as fs from "fs";
import { promisify } from "util";

import { remove } from "fs-extra";

// Движок публикуется с мапами и исходниками. после просто перекладывается в папку. надо исходники из продовой папки почистить
// + выпилить из сборки dev-билды форм - {gfv}.js. Оставив только {gfv}.min.js
// подробнее FS-8649
export async function clearSourceMapForProduction(resourcesDirectory: string) {
    const scriptsPath = path.join(resourcesDirectory, "public", "scripts");
    const stylePath = path.join(resourcesDirectory, "public", "styles");
    const globAsync: (pattern: string | string[]) => Promise<string[]> = promisify(fs.glob);
    const filesToDelete = [
        await globAsync(`${scriptsPath}/!(*.min.js|client.js)`),
        await globAsync(`${stylePath}/!(*.min.css)`),
    ].flat(1);

    for (const file of filesToDelete) {
        await remove(file);
    }
}
